/**
 * The name of the default TMR backend authentication token.
 *
 * @namespace tmrApiAuthToken
 * @type {ngConstant}
 */
export const constant = ['tmrApiAuthToken', 'authorization']
